// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"About_wrapper__cHd9m","header":"About_header__20lH0","portrait":"About_portrait__1cYp6","copy":"About_copy__2N5mn"};